// @ts-ignore MDC botched ES5 importing
import * as domUtils from '@material/dom/dist/mdc.dom.js';
var _FocusTrap = domUtils.focusTrap.FocusTrap;
export var focusTrapFactory = function (el, focusOptions) { return new _FocusTrap(el, focusOptions); };
